import { Field, FormSpy } from 'react-final-form';

// This component is a workaround for the issue where dirty fields are unmounted when navigating between pages in a form
// https://github.com/final-form/react-final-form/issues/803#issuecomment-1002394148
export const FixDirtyFormIssue = () => (
  <FormSpy subscription={{ dirtyFields: true }}>
    {({ dirtyFields }) =>
      // This keeps dirty fields mounted between pages.
      Object.keys(dirtyFields).map((name, idx) => (
        <Field key={idx} name={name} subscription={{}} render={() => null} />
      ))
    }
  </FormSpy>
);
